import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'pt', 'es'],
    fallbackLng: 'en',
    // --- MUDANÇA IMPORTANTE: Força o uso apenas do idioma (en), ignorando a região (US) ---
    load: 'languageOnly', 
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      // Adiciona um timestamp para evitar cache antigo no celular durante o desenvolvimento
      queryStringParams: { v: '1.0.0' } 
    },
    // Garante que o react não tente escapar os valores (já que o React faz isso)
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;